import ApplicationSimpleForm from './ApplicationSimpleForm'

export default ApplicationSimpleForm
